<template>
    <v-card>
        <v-card-title>
            {{ $t('Osastot') }}
        </v-card-title>
        <v-card-text>
            <v-alert color="info" text>
                {{ $t('department-info') }}
            </v-alert>
            <v-btn color="primary" class="mb-4" @click="newDepartment">
                <span>{{ $t("Uusi osasto") }}</span>
            </v-btn>

            <v-data-table :headers="headers" :items="departments" :server-items-length="totalDepartments"
                :loading="loading">
                <template v-slot:item.name="{ item }">
                    <a @click="editDepartment(item.id)">
                        {{ item.name }}
                    </a>
                </template>
                <template v-slot:item.is_active="{ item }">
                    <v-icon v-if="item.is_active" size="24" color="success">{{ icons.mdiCheckboxMarkedCircle }}
                    </v-icon>
                    <v-icon v-else size="24" color="error">{{ icons.mdiCloseCircle }}
                    </v-icon>
                </template>
            </v-data-table>
            <v-dialog :key="editDepartmentId" v-model="formDialogVisible" max-width="720px" persistent>

                <v-card>
                    <div class="text-right pr-2 pt-2">
                        <v-icon class="text-right" size="32" @click="formDialogVisible = false">{{ icons.mdiCloseCircle
                        }}
                        </v-icon>
                    </div>
                    <v-card-text class="pt-6">
                        <departmentForm :id="editDepartmentId" @saved="refresh"></departmentForm>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card-text>
    </v-card>
</template>

<script>
import { ref, onMounted } from "@vue/composition-api";
import { getDepartments, saveDepartment, deleteDepartment } from '@/api/admin/departments.admin.api.js'
import adminApi from "@/api/admin";
import { mdiCheckboxMarkedCircle, mdiCloseCircle, mdiPlus } from "@mdi/js";
import departmentForm from './components/department_form.vue';
import useAuth from "@/useAuth";

export default {
    components: {
        departmentForm
    },
    setup() {
        const loading = ref(false);
        const departments = ref([]);
        const totalDepartments = ref(0);
        const editDepartmentId = ref(null);
        const formDialogVisible = ref(false);
        const { tenant } = useAuth();

        const fetchDepartments = async () => {
            loading.value = true
            const response = await adminApi.getDepartments()
            if (response.ok) {
                departments.value = response.data;
                totalDepartments.value = response.data.length;
                tenant.value.departments = departments.value;
            }
            else {
                alert(res.error);
            }
            loading.value = false;
        }

        const editDepartment = (id) => {
            editDepartmentId.value = id;
            formDialogVisible.value = true;
        }

        const newDepartment = async () => {
            editDepartmentId.value = null;
            formDialogVisible.value = true;
        }

        const refresh = async (id) => {
            editDepartmentId.value = id;
            formDialogVisible.value = false;
            fetchDepartments();
        }

        onMounted(() => {
            fetchDepartments()
        });


        const headers = ref([
            {
                text: 'Nimi',
                value: 'name',
            },
            {
                text: 'Aktiivinen',
                value: 'is_active',
            },
        ]);

        return {
            loading,
            departments,
            totalDepartments,
            editDepartment,
            editDepartmentId,
            formDialogVisible,
            refresh,
            newDepartment,
            headers,
            tenant,
            icons: {
                mdiCheckboxMarkedCircle,
                mdiCloseCircle,
                mdiPlus,
            },
        }
    }

}
</script>

<style scoped>
.v-data-table {
    width: 100%;
}
</style>
